import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import ManualAddressEntry from './manual-address-entry';

export class Address extends PureComponent {
  static propTypes = {
    type: PropTypes.string
  };

  static defaultProps = {
    type: 'home'
  };

  state = {
    manualEntry: true
  };

  render() {
    const { manualEntry } = this.state;

    return (
      <Fragment>
        {manualEntry && <ManualAddressEntry {...this.props} />}
      </Fragment>
    );
  }
}

export default Address;
